

































































































































































import DatasourceServices from '@/services/datasource';
import { DataprocessDto } from '@/services/dataprocess';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';
import RefData from '../../components/ref-data.vue';
import moment from 'moment';
import 'moment/locale/zh-cn';
@Component({
  components: { RefData }
})
export default class DataprocessFlinksql2 extends Vue {
  @PropSync('formData') syncFormData!: DataprocessDto;
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;

  dsSrv = new DatasourceServices();
  activeKey: string = '0';
  expandIconPosition: string = 'left';
  visibleRefData = false;
  visibleMore = false;

  startupModeList = ['group-offsets', 'earliest-offset', 'latest-offset', 'timestamp', 'specific-offsets'];
  incrementTypeList = ['无','自增主键', '时间', 'HIVE分区'];

  dsTypeList = [
      {key: 'MySQL', value: 'MySQL'},
      {key: 'PostgreSQL', value: 'PostgreSQL'},
      {key: 'SQLServer', value: 'SQLServer'},
      {key: 'Oracle', value: 'Oracle'},
      {key: 'elasticsearch', value: 'elasticsearch'},
      {key: 'mongoDB', value: 'mongoDB'},
      {key: 'kafka', value: 'kafka'},
      {key: 'hive', value: 'hive'},
      {key: 'hbase', value: 'hbase'},
      {key: 'csvFile', value: 'csvFile'},
      {key: 'oss', value: 'oss'},
      {key: 'restapi', value: 'restapi'},
      {key: 'redis', value: 'redis'},
      {key: 'doris', value: 'doris'}
  ];
  dsObjList: any[] = [];

  mounted() {
    this.getDsList();
  }

  async onChangeDsType(e: string, index: number) {
    if (!this.syncFormData.sourcesDsConfig || this.syncFormData.sourcesDsConfig.length <= 0) return ;
    let v = this.syncFormData.sourcesDsConfig[index];
    v.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: e });
    this.$forceUpdate();
  }

  async onChangeDs(e: number, index: number) {
    if (!this.syncFormData.sourcesDsConfig || this.syncFormData.sourcesDsConfig.length <= 0) return ;
    let v = this.syncFormData.sourcesDsConfig[index];
    v.sourceDsId = e;
    let datatsource = v.dsList.filter((v: any) => v.id == e);
    v.sourceDsName = datatsource && datatsource.length > 0 ? datatsource[0].dsName : '';
    if(!v.sourceDsType) { v.sourceDsType = datatsource[0].dsType; } 
    v.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: e });
    this.$forceUpdate();
  }

  async onChangeTable(e: number, index: number) {
    if (!this.syncFormData.sourcesDsConfig || this.syncFormData.sourcesDsConfig.length <= 0) return ;
    let v = this.syncFormData.sourcesDsConfig[index];
    v.sourceDsTableId = e;
    let table = v.tableList.filter((v: any) => v.id == e);
    v.sourceDsTableName = table && table.length > 0 ? table[0].tableNameEn : '';
    v.sourceDsColumns = await this.dsSrv.columns({ status_eq: 0, tableId_eq: e });

    this.$forceUpdate();
  }

  @Watch('syncFormData.id')
  async getDsList() {
    if (!this.syncFormData.sourcesDsConfig || this.syncFormData.sourcesDsConfig.length <= 0) return ;
    if (this.syncFormData.id) {
      for (let i = 0; i < this.syncFormData.sourcesDsConfig.length; i++) {
          let v = this.syncFormData.sourcesDsConfig[i];
          v.dsList = await this.dsSrv.getList({ status_eq: 0, dsType_eq: v.sourceDsType });
          v.tableList = await this.dsSrv.tables({ status_eq: 0, sourceId_eq: v.sourceDsId });
      }
    } else {
      let ret = await this.dsSrv.getList({ status_eq: 0 });
      this.dsObjList = ret;
      for (let i = 0; i < this.syncFormData.sourcesDsConfig.length; i++) {
          this.syncFormData.sourcesDsConfig[i].dsList = ret;
      }
    }
  }

  filterOption(input: string, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  handleClick(index: number) {
    this.syncFormData.sourcesDsConfig && this.syncFormData.sourcesDsConfig.splice(index, 1);
  }

  @Watch('syncFormData.sourcesDsConfig.length')
  onFormDataChange(newVal: number, oldVal: number) {
    debugger
    if(newVal !== oldVal) {
      let index = newVal - 1;
      this.activeKey = '' + index ;
      // this.$nextTick(() => {
      //   this.activeKey = '' + index ;
      // });
    }
  }

  addSource() {
    if (this.syncFormData.sourcesDsConfig) {
      this.syncFormData.sourcesDsConfig.push({
        sourceDsId: 0,
        sourceDsType: '',
        sourceDsName: '',
        sourceDsTableName: '',
        sourceDsTableLogicName: '',
        sourceDsColumns: [],
        // 偏移量类型:0-最新记录,1-最早记录,2-自定义参数
        //startMode: 0,
        // 自定义偏移量
        startLocation: '',
        incrementColumn: '',
        incrementColumnType: '',
        restoreColumn: '',
        restoreColumnType: '',
        kafkaGroupId: '',
        // 时间特征 0-处理时间，1-事件时间
        timeFlag: 0,
        // 时间字段名称
        timeColumn1: '',
        timeColumn2: '',
        // Watermark值与Event Time值的偏移量，单位为毫秒
        timeOffset: 0,
        parallelism: 1,
        dsList: this.dsObjList,
        tableList: [],
      });
    }
  }

  removeList(index1: number, index2: number) {
    this.syncFormData.sourcesDsConfig && this.syncFormData.sourcesDsConfig[index1].sourceDsColumns?.splice(index2, 1);
  }

  async confirm() {
    const must: { field: 'sourceDsId' | 'sourceDsType' | 'sourceDsName' | 'sourceDsTableId' | 'sourceDsTableName' ; msessage: string }[] = [
        { field: 'sourceDsId', msessage: '源数据源不能为空' },
        { field: 'sourceDsType', msessage: '源数据源类型不能为空' },
        { field: 'sourceDsName', msessage: '源数据源不能为空' },
        { field: 'sourceDsTableId', msessage: '源数据对象不能为空' },
        { field: 'sourceDsTableName', msessage: '源数据对象不能为空' },
    ];
    if (this.syncFormData.sourcesDsConfig && this.syncFormData.sourcesDsConfig.length > 0) {
      for (let i = 0; i < this.syncFormData.sourcesDsConfig.length; i++) {
        let v = this.syncFormData.sourcesDsConfig[i];
        for (let val of must) {
          if (!v[val.field]) {
            this.$message.error(val.msessage);
            return false;
          }
        }
        
        if (this.syncFormData.jobConfig) {
            if (v.pollingInterval && v.pollingInterval > 0) {
              this.syncFormData.jobConfig.jobType = 1;
            } else if (v.sourceDsType === 'kafka') {
              this.syncFormData.jobConfig.jobType = 1;
            }
        }
      }
    }

    this.syncVisible = false;
    return true;
  }
  
  columns = [{
      title: '字段名',
      dataIndex: 'columnNameEn',
      key: 'columnNameEn',
      width: 60,
      ellipsis: true,
    },
    {
      title: '字段类型',
      dataIndex: 'dataTypeEn',
      key: 'dataTypeEn',
      width: 40,
      ellipsis: true,
    },
    {
      title: '是否主键',
      dataIndex: 'pkFlag',
      key: 'pkFlag',
      width: 30,
      scopedSlots: { customRender: 'pkFlag' },
    },
    {
      title: '是否分区',
      dataIndex: 'partitionFlag',
      key: 'partitionFlag',
      width: 30,
      scopedSlots: { customRender: 'partitionFlag' },
    },
    {
      title: '是否增量',
      dataIndex: 'incrementFlag',
      key: 'incrementFlag',
      width: 30,
      scopedSlots: { customRender: 'incrementFlag' },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 40,
      scopedSlots: { customRender: 'operation' },
    },
  ];

}
